/* eslint-disable no-unused-vars */
// Format: enumKey = "Header Display" // field/colId: enumKey (unless noted)
export enum TableHeaderField {
  // ----- ACTION SUMMARY ---- //
  // Mainly used on the main action summary table:
  status = "Status", // field: status
  esid = "Trade ID", // field: esid
  type = "Type", // field: type
  structureType = "Structure", // field: structureType
  provider = "CP", // field: provider
  details = "Details", // field: details
  latestActivity = "Latest Activity", // field: latestActivity
  actionedAt = "Actioned At", // field: actionedAt
  actionedBy = "Actioned By", // field: actionedBy
  owner = "Owner", // field: owner
  currency = "Currency", // field: currencies (API-provided comma-separated list of currencies across legs)
  // Headers mainly for the legs in trades:
  // order = "Order", // May not be used
  orderEmptyHeader = "", // field: order
  bid = "Bid", // field: bid
  bidRepo = "Repo Bid", // field: bid (repo context)
  ask = "Ask", // field: ask
  askRepo = "Repo Ask", // field: ask (repo context)
  mid = "Mid", // field: mid
  midRepo = "Repo Mid", // field: mid (repo context)
  direction = "Direction", // field: direction
  notionalLeg1 = "Size", // field: notionalLeg1
  security = "Security", // field: security - Matching Group2
  securityName = "Security", // field: securityName - Matching Group2
  coupon = "Coupon", // field: coupon
  settlementDate = "Settlement", // field: settlementDate - Matching Group1
  level = "Level", // field: level
  refAsset = "Spread Asset", // field: referenceAsset - ORDER once sent
  refSpread = "Spread", // field: referenceSpread - ORDER once sent
  minClip = "Min Clip", // field: minClip
  fillQuantity = "Fill Quantity", // field: fillQuantity - ORDER
  filledPercent = "% Filled", // field: filledPercent - ORDER
  filledAt = "Actioned At", // field: filledAt - ORDER
  fillPrice = "Filled At", // field: fillPrice - ORDER
  expiryDate = "Expiry", // field: expiryDate
  deliveryDate = "Termination", // field: deliveryDate
  indicativeMid = "Indicative Mid", // field: indicativeMid
  notionalLeg2 = "Size Leg 2", // field: notionalLeg2
  dealtStrike = "Strike", // field: dealtStrike
  strike = "Strike", // field: strike
  cpiLeg1 = "CPI", // field: cpi
  cpiIndex = "Index", // field: cpiIndex
  quotedSize = "Quoted Size", // field: quotedSize
  percentQuoted = "% Quoted", // field: percentQuoted (LQC-275 — bar showing quotedSize/notionalLeg1)
  percentIceberg = "Iceberg", // field: percentIceberg (LQC-922 — bar showing releaseSize per CP)
  feeAdjustedQuote = "Dealt Price", // field: feeAdjustedQuote
  dealtRepoRate = "Dealt Repo Rate", // field: dealtRepoRate
  refPrice = "Ref Price", // field: refPrice
  // QUOTE EXPIRY (later phase) - a duration the RP types, not a timestamp.
  // Trade expiry uses expiryEnd at ES level. See docs/features/TRADE_EXPIRY.md
  validUntil = "Valid For", // field: validUntil
  expiryEnd = "Expires", // field: expiryEnd - TRADE expiry, ES level (LQC-2171)
  action = "Action", // field: action
  book = "Book", // field: book
  // NPV?
  leg = "Leg", // field: leg
  cash = "", // field: cash - "Cash"
  dealer = "Unwind Amount", // field: dealer - was "Dealer"
  executionFee = "Fee", // field: executionFee
  dealtFee = "", // field: dealtFee - "Cash (fee inc.)"
  indicativeCash = "Indicative Unwind Amount", // field: indicativeCash - Was 'indicative Cash' - 14910
  unwind = "Unwind Type", // field: unwind

  //--------- ACTION SUMMARY LEG TABLE -----------//
  transactionType = "Transaction Type", // field: transactionType
  npv = "NPV", // field: npv
  recoupon = "Recoupon", // field: recoupon
  indicativeNPV = "Indicative NPV", // field: indicativeNPV

  // --- ACTION SUMMARY LEG TABLE: FRN specific (LQC-2153) --- //
  referenceIndex = "Reference Index", // field: referenceIndex - FRN
  quotedMargin = "Quoted Margin", // field: quotedMargin - FRN
  currentCoupon = "Current Coupon", // field: coupon - FRN

  // --- ACTION SUMMARY LEG TABLE: Order specific --- //
  referencePrice = "Set Level", // field: referencePrice - ORDER
  referenceSpread = "Set Spread", // field: referenceSpread - ORDER
  referenceAsset = "Set Asset", // field: referenceAsset - ORDER

  // ----- TRADE CREATION ---- //
  effectiveDate = "Settlement", // field: effectiveDate - Matching Group1
  dV01 = "Risk", // field: dV01
  extStructureId = "External ID", // field: extStructureId
  dateCreated = "Date Created", // field: dateCreated
  source = "Source", // field: source - where a block came from (API / FIX / SFTP / Manual)
  portfolio = "Portfolio", // field: portfolio
  portfolioName = "Portfolio Name", // field: portfolioName
  complianceStatus = "Compliance Status", // field: complianceStatus
  newIssue = "New Issue", // field: newIssue

  // ----- PRICES ---- //
  isin = "ISIN", // field: isin
  bidPrice = "Bid Price", // field: bidPrice
  midPrice = "Mid Price", // field: midPrice
  askPrice = "Ask Price", // field: askPrice
  // LQC-2575 - some bonds quote in yield, some in price, so both sets are named
  // explicitly. Fields stay bid/mid/ask (IPriceSummaryModel) - only the header says yield.
  bidYield = "Bid Yield", // field: bid
  midYield = "Mid Yield", // field: mid
  askYield = "Ask Yield", // field: ask
  notation = "Notation", // field: notation
  couponRate = "Coupon", // field: couponRate
  // -- Detail Prices -- //
  customerCode = "", // field: customerCode
  priceDate = "Price Date", // field: priceDate - THIS IS THE ONLY FIELD WITH DATE on the end of it.

  // ----- AXE CREATION -------//
  axeSubstring = "Axe Substring", // field: axeSubstring
  maturityDate = "Maturity Date", // field: maturityDate
  providedDate = "Provided Date", // field: providedDate
  nominal = "Nominal", // field: nominal
  rate = "Rate", // field: rate
  issuerCountry = "Issuer Country", // field: issuerCountry
  issuer = "Issuer", // field: issuer

  // --- ReferenceRate --- //
  ReferenceRates = "OIS Fixing", // field: referenceRates
}
